import { useQuery } from '@tanstack/react-query';
import { getPrincipalFeatures } from '../utils/principal-service/principal-endpoints';

export const usePrincipalFeatures = (principalId: string) => {
  const { data: principalFeatures } = useQuery({
    queryFn: () => getPrincipalFeatures(principalId),
    queryKey: ['principalFeatureAccessRights'],
    select: ({ data }) => data.features,
  });
  return { data: principalFeatures };
};
